import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from 'design-system';

import { MAX_SELECTED_CURVES, MAX_SELECTED_SYMBOLS } from '@/config/constants';
import { SELECTOR_MODES } from '../../state/symbolSelector.slice';

const LimitDialog = ({
  handleClose,
  open,
  selectorMode = SELECTOR_MODES.NEUTRAL
}: {
  handleClose: () => void;
  open: boolean;
  selectorMode?: SELECTOR_MODES;
}) => {
  const isForwardCurve = selectorMode === SELECTOR_MODES.FORWARD_CURVE;
  return (
    <Dialog
      open={open}
      onOpenChange={nextOpen => {
        if (!nextOpen) handleClose();
      }}
    >
      <DialogContent className='bg-gx-main-background text-gx-text'>
        <DialogHeader>
          <DialogTitle>Too many!</DialogTitle>
        </DialogHeader>
        <DialogDescription>
          {isForwardCurve
            ? `Please select fewer than ${MAX_SELECTED_CURVES} curves.`
            : `Please select fewer than ${MAX_SELECTED_SYMBOLS}.`}
        </DialogDescription>
        <DialogFooter>
          <Button onClick={handleClose}>Ok</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default LimitDialog;
